module.exports = __webpack_public_path__ + "static/holsum_logo_no_copyright-5254df3ef43833086d754021bc286de4.png";